import React from 'react';
import { Grid, InputAdornment, Typography } from '@material-ui/core';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import TextInputFieldWithValidation from '../../ValidationFormElements/TextInputFieldWithValidation';
import EmailIcon from '../../../icons/Email';
import MainButton from '../../MUI/MainButton';
import { clearSentMail, sendRecoveryLink } from '../../../redux/modules/auth';
import forgotPasswordSchema from '../../../validations/auth/forgotPasswordSchema';

import useStyles from '../LoginForm/makeStyles';

const ForgotPasswordForm = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { mailSent } = useSelector((store) => store.auth);

  const classes = useStyles();

  const { register, handleSubmit, errors, clearError } = useForm({
    validationSchema: forgotPasswordSchema,
    mode: 'onSubmit',
  });

  const onSubmit = (email) => {
    dispatch(sendRecoveryLink(email));
  };
  return (
    <Grid container spacing={4} justifyContent="center">
      <Grid item xs={11}>
        <Typography className={classes.headerText} align="center">
          {t('forgotPassword.recovery')}
        </Typography>
        {!mailSent && (
          <Typography className={classes.subHeaderText} align="center">
            {t('forgotPassword.subHeader')}
          </Typography>
        )}
      </Grid>
      {!mailSent && (
        <>
          <Grid item xs={11}>
            <TextInputFieldWithValidation
              required
              formProps={{ errors, clearError }}
              placeholder={t('login.email')}
              name="email"
              register={register}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={11}>
            <MainButton
              variant="contained"
              onClick={() => handleSubmit(onSubmit)()}
              className={classes.button}
              color="primary"
              width="fullWidth"
            >
              {t('button.approve')}
            </MainButton>
          </Grid>
        </>
      )}
      {mailSent && (
        <Grid item xs={11}>
          <Grid container spacing={2} justifyContent="center">
            <Grid item xs={11} className={classes.mailSentMessage}>
              {t('forgotPassword.mailSent')}
            </Grid>
            <Grid item xs={11} className={classes.cancel}>
              <MainButton
                width="fullWidth"
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={() => dispatch(clearSentMail())}
              >
                {t('forgotPassword.back')}
              </MainButton>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default ForgotPasswordForm;
